"use client";

import { createContext, useContext, useEffect, useRef, ReactNode } from "react";
import { usePathname } from "next/navigation";

interface NavigationProviderProps {
  children: ReactNode;
}

const NavigationContext = createContext<string[]>([]);

export const NavigationProvider = ({ children }: NavigationProviderProps) => {
  const pathname = usePathname();
  const historyStack = useRef<string[]>([]);

  useEffect(() => {
    if (!historyStack.current.includes(pathname)) {
      historyStack.current.push(pathname);
    }
  }, [pathname]);

  //Disable RightClick copy image or Link Option
  // useEffect(() => {
  //   const handleContextMenu = (e: MouseEvent) => e.preventDefault();
  //   document.addEventListener("contextmenu", handleContextMenu);

  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //   };
  // }, []);

  return (
    <NavigationContext.Provider value={historyStack.current}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigationHistory = () => useContext(NavigationContext);
